export default __webpack_public_path__ + "static/SRUS LF035 - Product Specifications & Technical Data-6e54af9657a0ef1a7ecd40eecd4356e8.pdf";